import { render, staticRenderFns } from "./QHierarchyAuditTable.vue?vue&type=template&id=54b97c80&scoped=true&"
import script from "./QHierarchyAuditTable.vue?vue&type=script&lang=js&"
export * from "./QHierarchyAuditTable.vue?vue&type=script&lang=js&"
import style0 from "./QHierarchyAuditTable.vue?vue&type=style&index=0&id=54b97c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b97c80",
  null
  
)

export default component.exports